import { render, staticRenderFns } from "./BusinessAddressSection.vue?vue&type=template&id=78b3efa8"
import script from "./BusinessAddressSection.vue?vue&type=script&lang=js"
export * from "./BusinessAddressSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports